class EditRoleModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    'ngInject';

    const sourceRole = $uibModalInstance.role;

    $scope.role = {
      roleName: sourceRole.roleName,
      roleDescription: sourceRole.roleDescription || '',
      text: sourceRole.text || ''
    };
    $scope.originalRole = angular.copy($scope.role);
    $scope.isNameEditable = $uibModalInstance.isNameEditable;
    $scope.errorMessage = '';
    $scope.saving = false;

    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    };

    $scope.missingRequiredValues = function () {
      return !$scope.role.roleName;
    };

    $scope.saveRole = function () {
      if ($scope.missingRequiredValues() || $scope.saving) {
        return;
      }

      const payload = {};

      if ($scope.isNameEditable && !angular.equals($scope.originalRole.roleName, $scope.role.roleName)) {
        payload.roleName = $scope.role.roleName;
      }
      if (!angular.equals($scope.originalRole.roleDescription, $scope.role.roleDescription)) {
        payload.roleDescription = $scope.role.roleDescription;
      }
      if (!angular.equals($scope.originalRole.text, $scope.role.text)) {
        payload.text = $scope.role.text;
      }

      if (Object.keys(payload).length === 0) {
        $uibModalInstance.dismiss();
        return;
      }

      $scope.saving = true;
      $scope.errorMessage = '';

      $http.patch(
        $rootScope.apiHost + '/api/admin/roles/' + sourceRole.id,
        payload,
        {withCredentials: true}
      ).then(function (success) {
        $uibModalInstance.close(success.data);
      }, function (failure) {
        $scope.saving = false;
        $scope.errorMessage = (failure.data && failure.data.message)
          ? failure.data.message
          : 'Could not update role.';
      });
    };
  }
}

export default EditRoleModalController;



// WEBPACK FOOTER //
// ./client/pages/admin/role-management/modals/editRoleModal/editRoleModal.controller.js